import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Payment = ({ paymentHardware, onPaymentDelete, onDispatchAdd }) => {
  const [isCompleting, setIsCompleting] = React.useState(false);
  const [showCheckmark, setShowCheckmark] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleComplete = (row) => {
    setIsCompleting(true);
    onDispatchAdd(row);
    setTimeout(() => {
      setIsCompleting(false);
      setShowCheckmark(true);
      setOpenDialog(true);
      setTimeout(() => {
        setShowCheckmark(false);
      }, 1000); // Duration for checkmark icon
    }, 1000); // Simulate animation duration
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Payment
      </Typography>
      <Grid container spacing={3}>
        {paymentHardware && paymentHardware.length > 0 ? (
          paymentHardware.map((row) => (
            <Grid item xs={12} key={row.id}>
              <Card sx={{ boxShadow: 3 }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    {row['Customer Name']}
                  </Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Place:</strong> {row.Place}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Date:</strong> {row.Date}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Time:</strong> {row.Time}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Serial No:</strong> {row['Serial No']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>System Name:</strong> {row['System Name']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Contact Number:</strong> {row['Contact Number']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer ID:</strong> {row['Customer ID']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Address:</strong> {row.Address}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer Issue:</strong> {row['Customer Issue']}</Typography>
                </CardContent>
                <CardActions>
                  
                  <Button size="small" color="success" onClick={() => handleComplete(row)} disabled={isCompleting || showCheckmark}>
                    {isCompleting ? <CircularProgress size={20} color="inherit" /> : (showCheckmark ? <CheckCircleIcon /> : 'Completed')}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body1">No payments.</Typography>
        )}
      </Grid>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Payment Completed</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The payment has been successfully processed and the item is ready for dispatch.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Payment;